import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {forkJoin, Observable } from 'rxjs';

import { ConfigService } from './config.service';
import { ElectricalInstallationConditionReport } from '../models/electrical-installation-condition-report/electrical-installation-condition-report';
import { ElectricalInstallationConditionReportPost } from '../models/electrical-installation-condition-report/electrical-installation-condition-report-post';
import { ElectricalInstallationConditionReportOverview } from '../models/electrical-installation-condition-report/electrical-installation-condition-report-overview';
import { FileService } from "./file.service";
import { OwnerElectricalInstallationConditionReportOverview } from '../models/electrical-installation-condition-report/owner-electrical-installation-condition-report-overview';
import {PropertyServicesSummary} from "../models/property-services/property-services-summary.interface";
import {mergeMap, tap} from "rxjs/operators";
import {GasSafetyCertificate} from "../models/gas-safety-certificate/gas-safety-certificate";
import {BoilerService} from "../models/boiler-service/boiler-service";

@Injectable()
export class ElectricalInstallationConditionReportService {
    constructor(private http: HttpClient, private configService: ConfigService, private fileService: FileService) {
    }

    getOverview(propertyReference: string): Observable<ElectricalInstallationConditionReportOverview> {
        return this.http.get<ElectricalInstallationConditionReportOverview>(`${this.configService.baseUrl}/manage/property/${propertyReference}/electrical-installation-condition-report/overview`);
    }

    getSummary(propertyReference: string) {
        return this.http.get<PropertyServicesSummary>(`${this.configService.baseUrl}/manage/property/${propertyReference}/electrical-installation-condition-report/summary`);
    }

    getList(propertyReference: string): Observable<ElectricalInstallationConditionReport[]> {
        return this.http.get<ElectricalInstallationConditionReport[]>(`${this.configService.baseUrl}/manage/property/${propertyReference}/electrical-installation-condition-report`);
    }

    getOwnerOverview(propertyReference: string): Observable<OwnerElectricalInstallationConditionReportOverview> {
        return this.http.get<OwnerElectricalInstallationConditionReportOverview>(`${this.configService.baseUrl}/owner/property/${propertyReference}/electrical-installation-condition-report/overview`);
    }

    getOwnerList(propertyReference: string): Observable<ElectricalInstallationConditionReport[]> {
        return this.http.get<ElectricalInstallationConditionReport[]>(`${this.configService.baseUrl}/owner/property/${propertyReference}/electrical-installation-condition-report`);
    }

    get(organisationReference: string, guid: string) {
        return this.http.get<ElectricalInstallationConditionReport>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/electrical-installation-condition-report/${guid}`);
    }
    add(organisationReference: string, model: ElectricalInstallationConditionReportPost): Observable<ElectricalInstallationConditionReport> {
        return forkJoin(
            this.fileService.uploadFiles(model.publicFiles),
            this.fileService.uploadFiles(model.privateFiles)
        ).pipe(
            tap(_ => model.publicFiles = this.fileService.prepareFilePosts(model.publicFiles)),
            tap(_ => model.privateFiles = this.fileService.prepareFilePosts(model.privateFiles)),
            mergeMap(_ => this.http.post<ElectricalInstallationConditionReport>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/electrical-installation-condition-report`, model))
        );
    }

    remove(propertyReference: string, item: ElectricalInstallationConditionReport): Observable<boolean> {
        return this.http.delete<boolean>(`${this.configService.baseUrl}/manage/property/${propertyReference}/electrical-installation-condition-report/${item.guid}`);
    }

    getOwnerElectricalInstallationConditionReport(propertyReference: string, guid: string): Observable<ElectricalInstallationConditionReport> {
        return this.http.get<ElectricalInstallationConditionReport>(`${this.configService.baseUrl}/owner/property/${propertyReference}/electrical-installation-condition-report/${guid}`);
    }
}
